import { query } from './query'
import { getBookingApiRoute } from '../helpers/bookingApiRoutes'

async function getBooking(bookingNumber) {
    const url = getBookingApiRoute('getBookingRoute')
    return await query(url, bookingNumber)
}

export { getBooking }
